import { useSnackbar, SnackbarType } from '@tapp.online/ui'

/** The package applies `?companyId=` links and leaves the feedback to the app; this is the dashboard's feedback. */
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('tapp-auth:company-switch-failed', (failure) => {
        const { addSnackbar } = useSnackbar()

        if (failure.reason === 'no-role') {
            addSnackbar({
                title: 'Company access',
                text: "You don't have access to that company",
                type: SnackbarType.WARNING,
                duration: 4000,
                variant: 'default',
                pauseOnHover: true,
                fullWidth: false
            })
            return
        }

        addSnackbar({
            title: 'Switch company',
            text: 'Could not switch company',
            type: SnackbarType.ERROR,
            duration: 4000,
            variant: 'default',
            pauseOnHover: true,
            fullWidth: false
        })
        console.error(failure.error)
    })
})
